"use strict";

angular.module('app.accessDenied', [])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.accessDenied', {
                templateUrl: 'components/accessDenied/accessDeniedView.html',
                controller: [
                    '$scope', '$stateParams',
                    function ($scope, $stateParams) {
                        $scope.message = $stateParams.message;
                        $scope.template = $stateParams.template;
                    }
                ],
                title: 'Access Denied',
                noSidebar: true,
                noTopControls: true,
                params: {
                    message: null,
                    template: null
                }
            })
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/accessDenied/accessDenied.js